
import SideMenu from 'Src/js/components/SideMenu.vue';
import VehicleEditor from 'JS/components/automotive/vehicle-editor/VehicleEditor.vue';
import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import { ICustomerVehicle } from 'JS/types/Automotive';

@Component({
	name: 'VehicleEditorSidebar',
	components: {
		SideMenu,
		VehicleEditor,
	}
})
export default class VehicleEditorSidebar extends Vue {

	/* Props
	============================================*/

	@Prop({ type: Object })
	readonly vehicle: ICustomerVehicle | null;

	/* Data
	============================================*/

	/* Methods
	============================================*/

	/* Watchers
	============================================*/

}

